import "react-toastify/dist/ReactToastify.css";

import "../styles/globals.css";
import "../styles/nprogress.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppProps } from "next/app";
import Router from "next/router";
import NProgress from "nprogress";
import { ToastContainer } from "react-toastify";

import { useDarkModeSync } from "../components/reuseables/theme.comp";
import usePosInit from "../hooks/usePosInit.hook";
import { GlobalStateProvider } from "../states/root.state";
import Fallback from "../components/common/fallback.comp";
import { ErrorBoundary } from "react-error-boundary";
import { logBoundaryError } from "../core/log.core";
import RestrictionCheckComp from "../components/restrictionCheck.comp";

Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

export default function MyApp({ Component, pageProps }: AppProps) {
  useDarkModeSync();

  return (
    <ErrorBoundary FallbackComponent={Fallback} onError={logBoundaryError}>
      <QueryClientProvider client={queryClient}>
        <PosInitComp />
        <GlobalStateProvider>
          <RestrictionCheckComp />
          <Component {...pageProps} />
          <ToastContainer />
        </GlobalStateProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

function PosInitComp() {
  usePosInit();

  return null;
}
